import { render, staticRenderFns } from "./digitalizar_encuesta.vue?vue&type=template&id=8108f53e&scoped=true"
import script from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
export * from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
import style0 from "./digitalizar_encuesta.vue?vue&type=style&index=0&id=8108f53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8108f53e",
  null
  
)

export default component.exports